import { SupportMessage, SupportMessageMetadata } from './support-assistant.types'

export interface PersistedSupportChatMessage {
  supportChatMessageId: string
  role: string
  text: string
  html?: string
  createdAt: string
  metadata?: SupportMessageMetadata
}

export const mapPersistedMessagesToSupportMessages = (
  messages: PersistedSupportChatMessage[],
  chatId: string
): SupportMessage[] =>
  messages
    .filter((msg) => msg?.role)
    .map((msg) => ({
      id: msg.supportChatMessageId,
      chatId,
      role: msg.role.toLowerCase() as 'user' | 'assistant',
      content: msg.text || '',
      html: msg.html,
      type: 'final',
      createdAt: msg.createdAt,
      metadata: msg.metadata,
    }))

// Retained rows from the previous filter or page must never end infinite scroll for the new one.
export const isLastAuditEventsPage = (
  pageEventCount: number,
  pageSize: number,
  isPreviousData: boolean
): boolean => !isPreviousData && pageEventCount > 0 && pageEventCount < pageSize
